import mAxios from './m-axios'
import {User} from './user'

export interface Resource {
  resource_id: string
  name: string
  desc: string
  updated_at: string
  author: User
  type: string
  image: string
  url: string
  suffix: string
  preview_url: string
}

export interface ListResourceOpt {
  offset: number
  limit: number
  type: string
  search: string
}

export const listResource = (opt: ListResourceOpt) => {
  return mAxios({
    method: 'get',
    url: '/api/resource',
    params: opt,
  }).then(res => res.data)
}

export const delResource = (resource_id: string) => {
  return mAxios({
    method: 'delete',
    url: '/api/resource',
    data: {
      resource_id: resource_id,
    },
  }).then(res => res.data)
}
